export function listenForSpacebar(e) {
	if (e.code === 'Space') {
		e.target.click();
	}
}
